export default {
	loadingData: 'Loading... Please wait',
};
